import React from "react"

import { ProductExternalDimensioning } from "entities/products/ui/product-external-dimensioning/ProductExternalDimensioning"

import { useProductPositionFormProductInformationContext } from "../contexts/ProductPositionFormProductInformationContext"

export const ProductPositionFormDimensioningTab = React.memo(() => {
  const { productInformation, isLoadingProductInformation: isLoading } =
    useProductPositionFormProductInformationContext()

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--dimensioning">
      <ProductExternalDimensioning
        productInformation={productInformation}
        isLoading={isLoading}
        hideEnvironmentalAttributes
      />
    </div>
  )
})
